import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./Footer.css";

import { Row, Col, Grid } from "react-bootstrap";
import cx from "classnames";

// Component
import LanguageSwitcher from "../LanguageSwitcher";
import Link from "../Link";

import PlayStoreImage from "/public/SiteImages/playStore.png";
import AppStoreImage from "/public/SiteImages/appStore.png";
import facebookIcon from "/public/SiteImages/facebook_blue.svg";
import twitterIcon from "/public/SiteImages/twitter_blue.svg";
import instagramIcon from "/public/SiteImages/instagram_blue.svg";

// Locale
import messages from "../../locale/messages";

import getEnabledBlog from "./getEnabledBlog.graphql";
import Logo from "../Logo/Logo";

class Footer extends React.Component {
  static propTypes = {
    siteName: PropTypes.string.isRequired,
    facebook: PropTypes.string,
    twitter: PropTypes.string,
    instagram: PropTypes.string,
    appAvailableStatus: PropTypes.string,
    playStoreUrl: PropTypes.string,
    appStoreUrl: PropTypes.string,
    formatMessage: PropTypes.any,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getEnabledBlog: PropTypes.array,
    }),
  };

  constructor(props) {
    super(props);
  }

  render() {
    const {
      siteName,
      facebook,
      twitter,
      instagram,
      appAvailableStatus,
      playStoreUrl,
      appStoreUrl,
    } = this.props;
    const {
      data: { getEnabledBlog },
    } = this.props;

    return (
      <footer className={s.fixedFooter}>
        <div className={s.positionRelative}>
          <div
            className={cx(
              s.footerBgBanner,
              s.root,
              "footerBannerImg",
              "footerBannerToggle",
              "commonWordBreak"
            )}
          >
            <div className={s.container}>
              <div className={cx(s.footerSectionContainer, "hidden-print")}>
                <Grid fluid>
                  <Row>
                    <div className={s.responsivePadding}>
                      <Col
                        sm={12}
                        md={2}
                        lg={2}
                        xs={12}
                        className={cx(s.responsiveMargin)}
                      >
                        <div className={cx(s.footerLogo)}>
                          <Logo
                            link={"/"}
                            className={cx(s.brand, s.brandImg)}
                          />
                        </div>
                      </Col>
                      <Col
                        sm={12}
                        md={10}
                        lg={10}
                        xs={12}
                        className={cx(s.responsiveMargin)}
                      >
                        <Row>
                          <Col
                            sm={3}
                            md={3}
                            lg={3}
                            xs={12}
                            className={cx(
                              s.responsiveMargin,
                              s.noPaddingMobile
                            )}
                          >
                            <label className={cx(s.landingLabel)}>
                              {siteName}
                            </label>
                            <ul className={s.listContainer}>
                              <li className={s.footerLinks}>
                                <Link
                                  to={"/about"}
                                  className={cx(
                                    s.textLink,
                                    "darkModeFooterLink"
                                  )}
                                >
                                  <FormattedMessage {...messages.about} />
                                </Link>
                              </li>
                              <li className={s.footerLinks}>
                                <Link
                                  to={"/contact"}
                                  className={cx(
                                    s.textLink,
                                    "darkModeFooterLink"
                                  )}
                                >
                                  <FormattedMessage {...messages.contactForm} />
                                </Link>
                              </li>
                              <li className={s.footerLinks}>
                                <Link
                                  to={"/faqs"}
                                  className={cx(
                                    s.textLink,
                                    "darkModeFooterLink"
                                  )}
                                >
                                  <FormattedMessage {...messages.staticFaqs} />
                                </Link>
                              </li>
                              {getEnabledBlog &&
                                getEnabledBlog.length > 0 &&
                                getEnabledBlog
                                  .filter(
                                    (item) =>
                                      item.footerCategory != "discover" &&
                                      item.footerCategory != "hosting"
                                  )
                                  .map((item) => {
                                    return (
                                      <li className={s.footerLinks}>
                                        <Link
                                          to={"/page/" + item.pageUrl}
                                          className={cx(
                                            s.textLink,
                                            "darkModeFooterLink"
                                          )}
                                        >
                                          {item.pageTitle}
                                        </Link>
                                      </li>
                                    );
                                  })}
                            </ul>
                          </Col>
                          <Col
                            sm={3}
                            md={3}
                            lg={3}
                            xs={12}
                            className={cx(
                              s.responsiveMargin,
                              s.noPaddingMobile
                            )}
                          >
                            <label className={cx(s.landingLabel)}>
                              <FormattedMessage {...messages.discover} />
                            </label>
                            <ul className={s.listContainer}>
                              <li className={s.footerLinks}>
                                <Link
                                  to={"/safety"}
                                  className={cx(
                                    s.textLink,
                                    "darkModeFooterLink"
                                  )}
                                >
                                  <FormattedMessage {...messages.trustSafety} />
                                </Link>
                              </li>
                              {/* <li className={s.footerLinks}>
                                <Link
                                  to={"/travel"}
                                  className={cx(
                                    s.textLink,
                                    "darkModeFooterLink"
                                  )}
                                >
                                  <FormattedMessage
                                    {...messages.travelCredit}
                                  />
                                </Link>
                              </li> */}
                              <li className={s.footerLinks}>
                                <Link
                                  to={"/partners"}
                                  className={cx(
                                    s.textLink,
                                    "darkModeFooterLink"
                                  )}
                                >
                                  <FormattedMessage {...messages.ourPartners} />
                                </Link>
                              </li>
                              {getEnabledBlog &&
                                getEnabledBlog.length > 0 &&
                                getEnabledBlog
                                  .filter(
                                    (item) => item.footerCategory == "discover"
                                  )
                                  .map((item) => {
                                    return (
                                      <li className={s.footerLinks}>
                                        <Link
                                          to={"/page/" + item.pageUrl}
                                          className={cx(
                                            s.textLink,
                                            "darkModeFooterLink"
                                          )}
                                        >
                                          {item.pageTitle}
                                        </Link>
                                      </li>
                                    );
                                  })}
                            </ul>
                          </Col>
                          <Col
                            sm={3}
                            md={3}
                            lg={3}
                            xs={12}
                            className={cx(
                              s.responsiveMargin,
                              s.noPaddingMobile
                            )}
                          >
                            <label className={cx(s.landingLabel)}>
                              <FormattedMessage {...messages.hosting} />
                            </label>
                            <ul className={s.listContainer}>
                              <li className={s.footerLinks}>
                                <Link
                                  to={"/whyhost"}
                                  className={cx(
                                    s.textLink,
                                    "darkModeFooterLink"
                                  )}
                                >
                                  <FormattedMessage {...messages.becomeAHost} />
                                </Link>
                              </li>
                              <li className={s.footerLinks}>
                                <Link
                                  to={"/privacy"}
                                  className={cx(
                                    s.textLink,
                                    "darkModeFooterLink"
                                  )}
                                >
                                  <FormattedMessage
                                    {...messages.termsPrivacy}
                                  />
                                </Link>
                              </li>
                              {getEnabledBlog &&
                                getEnabledBlog.length > 0 &&
                                getEnabledBlog
                                  .filter(
                                    (item) => item.footerCategory == "hosting"
                                  )
                                  .map((item) => {
                                    return (
                                      <li className={s.footerLinks}>
                                        <Link
                                          to={"/page/" + item.pageUrl}
                                          className={cx(
                                            s.textLink,
                                            "darkModeFooterLink"
                                          )}
                                        >
                                          {item.pageTitle}
                                        </Link>
                                      </li>
                                    );
                                  })}
                            </ul>
                          </Col>
                          <Col
                            sm={3}
                            md={3}
                            lg={3}
                            xs={12}
                            className={cx(
                              s.responsiveMargin,
                              s.noPaddingMobile
                            )}
                          >
                            {/* {appAvailableStatus == 1 &&
                              (playStoreUrl || appStoreUrl) && ( */}
                            <div>
                              <label className={cx(s.landingLabel)}>
                                <FormattedMessage
                                  {...messages.appsAvailableOn}
                                />
                              </label>
                              <div className={cx(s.spaceTop21, s.iosFlex)}>
                                {" "}
                                {facebook && (
                                  <a
                                    href={facebook || ""}
                                    target="_blank"
                                    className={cx(s.shareIcon, "shareIconRtl")}
                                  >
                                    <img
                                      alt=""
                                      src={facebookIcon}
                                      className={s.imageSocial}
                                    />
                                  </a>
                                )}
                                {twitter && (
                                  <a
                                    href={twitter || ""}
                                    target="_blank"
                                    className={cx(s.shareIcon, "shareIconRtl")}
                                  >
                                    <img
                                      alt=""
                                      src={twitterIcon}
                                      className={s.imageSocial}
                                    />
                                  </a>
                                )}
                                {instagram && (
                                  <a
                                    href={instagram || ""}
                                    target="_blank"
                                    className={cx(s.shareIcon, "shareIconRtl")}
                                  >
                                    <img
                                      alt=""
                                      src={instagramIcon}
                                      className={s.imageSocial}
                                    />
                                  </a>
                                )}
                              </div>

                              {/* <div className={cx(s.spaceTop21, s.iosFlex)}>
                                    {playStoreUrl && (
                                      <a
                                        href={playStoreUrl || ""}
                                        target="_blank"
                                        className={s.displayInlineBlock}
                                      >
                                        <img alt="Image" src={PlayStoreImage} />
                                      </a>
                                    )}
                                    {appStoreUrl && (
                                      <a
                                        href={appStoreUrl || ""}
                                        target="_blank"
                                        className={s.displayInlineBlock}
                                      >
                                        <img alt="Image" src={AppStoreImage} />
                                      </a>
                                    )}
                                  </div> */}
                            </div>
                            {/* )} */}
                          </Col>
                        </Row>
                      </Col>
                    </div>
                  </Row>

                  <Row
                    className={cx(
                      s.copyrightSection,
                      s.copyrightSpaceTop,
                      s.copyRightTabNoMargin
                    )}
                  >
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className={`${s.noPaddingMobile} ${s.textCenter}`}
                    >
                      <span
                        className={cx(
                          s.text,
                          s.footerSiteName,
                          "darkModeFooterLink"
                        )}
                      >
                        © {siteName}.
                      </span>
                    </Col>
                    {/* <Col
                      xs={6}
                      sm={8}
                      md={8}
                      lg={5}
                      className={cx(s.socialIcons, "socialIconsFooterRTL")}
                    >
                      {facebook && (
                        <a
                          href={facebook || ""}
                          target="_blank"
                          className={cx(s.shareIcon, "shareIconRtl")}
                        >
                          <img alt="" src={facebookIcon} />
                        </a>
                      )}
                      {twitter && (
                        <a
                          href={twitter || ""}
                          target="_blank"
                          className={cx(s.shareIcon, "shareIconRtl")}
                        >
                          <img alt="" src={twitterIcon} />
                        </a>
                      )}
                      {instagram && (
                        <a
                          href={instagram || ""}
                          target="_blank"
                          className={cx(s.shareIcon, "shareIconRtl")}
                        >
                          <img alt="" src={instagramIcon} />
                        </a>
                      )}
                    </Col> */}
                  </Row>
                </Grid>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

const mapState = (state) => ({
  siteName: state?.siteSettings?.data?.siteName || "",
  facebook: state?.siteSettings?.data?.facebookLink || "",
  twitter: state?.siteSettings?.data?.twitterLink || "",
  instagram: state?.siteSettings?.data?.instagramLink || "",
  appAvailableStatus: state?.siteSettings?.data?.appAvailableStatus || false,
  playStoreUrl: state?.siteSettings?.data?.playStoreUrl || "",
  appStoreUrl: state?.siteSettings?.data?.appStoreUrl || "",
});

const mapDispatch = {};

export default compose(
  injectIntl,
  withStyles(s),
  connect(mapState, mapDispatch),
  graphql(getEnabledBlog, {
    options: {
      fetchPolicy: "network-only",
      ssr: false,
    },
  })
)(Footer);
